import { FaUmbrella, FaMoneyCheckAlt, FaChartBar, FaBook, FaMoneyCheck, FaWallet } from "react-icons/fa";

const servicesData = [
    {
        id: 1,
        icon: <FaUmbrella />,
        title: "Audit & Assurance",
        info: "We bring Assurance by delivering true advisory to assist you in achieving your business objectives.",
    },
    {
        id: 2,
        icon: <FaMoneyCheckAlt />,
        title: "Financial Consulting",
        info: "We offer personalized financial consultancy to analyse your business finances easily.",
    },
    {
        id: 3,
        icon: <FaChartBar />,
        title: "Trades & Stocks",
        info: "We provide you genuine trading advisory & guide you in finding your way in the Stock market.",
    },
    {
        id: 4,
        icon: <FaBook />,
        title: "Strategic Planning",
        info: "We come up with the strategy - you implement it and see how your business steps up.",
    },
    {
        id: 5,
        icon: <FaMoneyCheck />,
        title: "Investment Program",
        info: "Manage your finance wisely. Invest your assets & get income on a going basic & no extra taxes.",
    },
    {
        id: 6,
        icon: <FaWallet />,
        title: "Bonds & Commodities",
        info: "Trust your funds to the professionals to grow your business and make you wealthy.",
    },
];

export default servicesData;